export const CopilotIntegrationRoutes = {
  ListTenants: '/copilot-integration',
} as const;
